import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useFetchContacts from "../../../disaster/hooks/useFetchContacts";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Personal Information",
  "Personal Information Divorce",
  "Children",
];

export default function PersonalInformation() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Personal Information Divorce");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  const { contactList } = useFetchContacts(setLoading);
  console.log("Contact List:", contactList);

  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );

  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const tableDataObj = {
    "Personal Information": tableData.personalInformationData,
    "Personal Information Divorce": tableData.personalInformationDivorceData,
    Children: tableData.childrenData,
  };

  const personalInfoTable = [{ title: "Personal Information", key: 1 }];

  const childrenTable = [{ title: "Children", key: 2 }];

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };

  const handleFormDataUpdate = (formData) => {
    const Payload = {
      Name: formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      Relationship: formData && formData.typeOfRelation,
      "Birth Date": formData && formData.birthday,
      Street: formData && formData.homeStreet,
      State: formData && formData.homeState,
      City: formData && formData.homeCity,
      Company: formData && formData.jobCompany,
      Zip: formData && formData.homeZip,
    };

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Personal Information</h2>
          <ToolTipCreator name={"Divorce_Personal_Information"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>

      {personalInfoTable.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() =>
            table.title === "Personal Information" || table.title === "Children"
              ? AddContact()
              : showModal(table.title)
          }
          options={contactList}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <CustomModal
        show={isModalVisible}
        fields={attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        handleFormDataUpdate={handleFormDataUpdate}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />

      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          {console.log("DisasterData:", disasterAttributeData)}

          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  if (formData && Object.keys(formData).length > 0) {
                    await createAttributes();
                  }
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      {childrenTable.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() =>
            table.title === "Personal Information" || table.title === "Children"
              ? AddContact()
              : showModal(table.title)
          }
          options={contactList}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
      <NewLoader isLoading={loading} />
    </div>
  );
}
